import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/departments/$deptKey')({

}).lazy(() => import('./$deptKey.lazy').then((d) => d.Route));
